module.exports = __webpack_public_path__ + "static/media/Calendar.947ed90d.PNG";